import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { postApiSetting } from "../assets/functions";
import { useEffect } from "react";
import { ToastContainer, toast } from 'react-toastify';

export default function Login ({setAuth}) {


    const LoginData = JSON.parse(sessionStorage.getItem('LoginData'))
    const { register, handleSubmit, formState:{ errors } } = useForm();

    const navigate = useNavigate();
    useEffect(()=>{
        if(LoginData){
            setAuth(false)
        }
    },[])

    const loginSubmit = async (data) => {
        // console.log(data);
        let settings = postApiSetting(data)
        try {
            // let res = await fetch('api/Admin/signIn', settings)
            let res = await fetch('/Admin/api/Admin/signIn', settings)
            let result = await res.json()
            console.log(res)
            console.log(result)
            if(res.status !== 200){
                // alert('something went wrong : '+ res.status)
                toast.error('something went wrong : '+ res.status, {position: 'top-center',});

            }else{
                if(result.data.responseCode === '00'){
                    // alert('SUCCESS : '+result.data.responseMsg)
                     sessionStorage.setItem('token',result.data.token)
                    setAuth(true)
                    navigate("/dashboard");
                }else{
                    // alert('FAILED : '+result.data.responseMsg)
                    toast.error('FAILED : '+result.data.responseMsg, {position: 'top-center',});

                }
            }
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <div className="container-fluid d-flex justify-content-center align-items-center vh-100 login-bg">
        <ToastContainer />
            <form className="ad-login-form p-5 shadow rounded" onSubmit={handleSubmit(loginSubmit)}>
                <h5 className="text-secondary mb-4"><strong>ADMIN LOGIN</strong></h5>
                <div className="mb-2">
                    <label className="form-label">Enter User Id <strong className='text-danger'>*</strong></label>
                    <input type="text" className="form-control shadow-none" {...register('userId', { required : { value:true, message:"This field is required" } })} />
                    {errors.userId && <strong className="text-danger"><small>{errors.userId.message}</small></strong>}
                </div>
                <div className="mb-2">
                    <label className="form-label">Enter Password <strong className='text-danger'>*</strong></label>
                    <input type="password" className="form-control shadow-none" {...register('password', { required : { value:true, message:"This field is required" } })} />
                    {errors.password && <strong className="text-danger"><small>{errors.password.message}</small></strong>}
                </div>
                <button type="submit" className="btn _themebg-0 text-white w-100 mt-2">Login</button>
            </form>
        </div>
    )
}